// document.addEventListener('DOMContentLoaded', function () {
//     const searchForm = document.getElementById('header-search-part');
//     const iframeFrame = document.getElementById('filialsuche-frame');

//     if (!searchForm || !iframeFrame) return;

//     const iframeBaseUrl = 'https://suche.geno-banken.de/#/?config.api_token=ebQcoRLfSJW6SGHmE2KgwEnQ&filters.dynamic_attributes.teilnahme_vrde=true&config.location_type=bank';

//     searchForm.addEventListener('submit', function (event) {
//         event.preventDefault();

//         const cityInput = document.getElementById('banken-suche');
//         const cityValue = cityInput ? cityInput.value.trim() : '';

//         iframeFrame.src = cityValue
//             ? `${iframeBaseUrl}&config.address=${encodeURIComponent(cityValue)}`
//             : iframeBaseUrl;
//     });
// });

document.addEventListener('DOMContentLoaded', function () {
    const widget = document.querySelector('vrnw-location-widget');

    if (!widget || !widget.shadowRoot) return;

    widget.shadowRoot.appendChild(Object.assign(document.createElement('style'), {
        textContent: `
            .border-brand-primary.border-\\[\\.0625rem\\] {
                border-radius: 1.5rem;
                overflow: hidden;
            }
        `,
    }));
});